import { FC, ReactElement, useEffect, useRef, useState, useSyncExternalStore } from "react";
import toast from "react-hot-toast";
import { fetchAsync, postAsync, postWithoutSign } from "../services/ApiHandler";
import { Button, Center, Checkbox, Group, Modal, ModalCloseButton, Radio } from "@mantine/core";
import { getPlanDescription, getPlanPrice, getPlanPriceText, getPlanSummary } from "../services/SubscriptionService";
import { getPlanName } from "../services/SubscriptionService";
import { StripeProduct } from "../model/StripeProduct";
import { useHeaderStore } from "./CommonHeader";
import { SetupIntentResponse } from "../model/SetupIntentResponse";
import { CardRegistrationDialog } from "./CardRegisterDialog";
import { Subscription } from "../model/Subscription";
import { StripeCheckoutResponse } from "../model/StripeCheckoutResponse";
import { getAccountId } from "../services/CookieHandler";
import { getSkyFlagUrl } from "../services/SkyFlagUtil";

export class SkyFlagDialogProps {
  onClick?: () => void;
  onCancel?: () => void;
}

export const SkyFlagDialog: FC<SkyFlagDialogProps> = ({ onClick, onCancel }) => {
  const [tosChecked,  setTosChecked] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [selectedSpan, setSelectedSpan] = useState('month');
  const { account } = useHeaderStore();
  const [stripeProducts, setStripeProducts] = useState<StripeProduct[]>([]);
  const [clientSecret, setClientSecret] = useState<string | undefined>(undefined);
  const [subscriptions, setSubscriptions] = useState<Subscription[] | undefined>(undefined);

  useEffect(() => {
  }, []);

  function openSkyFlagTask(){
    const url = getSkyFlagUrl();
    window.open(url, '_blank');
  }


  function buildPriceText(span: string){
    var isSelected = selectedSpan === span;
    const isMonth = span === 'month';

    return <>
    <div className="flex justify-between items-center mb-3">
      <Radio color="#0909FF" value={span}></Radio>
      <div onClick={() => setSelectedSpan(span)} className={`clickable border rounded-md p-2 w-full ml-4 justify-between ${isSelected ? 'border-[#0909FF]' : ''} ${isSelected ? 'bg-[#B0B0F466]' : 'bg-white'}`}>
        <div className="flex justify-between">
          { (subscriptions !== undefined && subscriptions?.length === 0) &&
          <span>
            <span className="text-sm font-bold line-through">1ヶ月</span><span className="action-primary font-bold ml-1">7日間</span>
          </span>
          }
          { (subscriptions !== undefined && subscriptions?.length >= 1) &&
          <span className="text-sm font-bold">{isMonth ? '1ヶ月' : '12ヶ月' }</span>
          }
          { !isMonth &&
          <span className="text-s bg-[#F416BF] text-white font-bold text-xs py-1 px-2 rounded-md">% OFF</span>
          }
        </div>
        <div className="flex justify-between">
          <span className="text-xs text-gray-500">text444</span>
          { (subscriptions !== undefined && subscriptions?.length === 0) &&
          <span>
            <span className="action-primary font-bold mr-1">¥0</span>
            <span>
              <span className="text-sm font-bold line-through">¥0</span>
              <span className="text-sm font-bold">/月</span>
            </span>
          </span>
          } 
          { (subscriptions !== undefined && subscriptions?.length >= 1) &&
          <span className="text-sm font-bold">¥0/月</span>
          }
        </div>
      </div>
    </div>
    </>
  }

  return <>
    { clientSecret &&
    <Modal fullScreen opened={true} onClose={() => {}}>
      <CardRegistrationDialog clientSecret={clientSecret} onClose={() => {}} />
    </Modal>
    }
    <div className="w-full sm:w-[800px] inline-block justify-center text-primary">
      <div className="">
        <div className="block sm:flex" >
          <div className="w-full sm:w-[50%] text-left ml-0 sm:ml-4 mt-10 mb-4 sm:mb-10 pr-4">
            <div className="text-xl font-bold">生成回数を手軽に増やせるチャンス！</div>
            <div className="text-2xl mt-4 font-bold text-[#0909FF]">タスクにトライして</div>
            <div className="text-2xl font-bold text-[#0909FF]">生成回数を増やそう</div>
            <div className="mt-4 text-sm text-gray-500">
            ・サービス登録、アンケート、お買い物、アプリインストールなど気になる案件にトライ！条件をクリアすると生成回数をプレゼント
            </div>
            <div className="mt-4 text-sm text-gray-500">
            ・案件の達成状況に応じて生成回数は自動で付与されます。
            </div>
            <div className="mt-8">
              <Button size="lg" fullWidth disabled={processing} className="text-primary gradation-button hover-button rounded bg-white w-full" style={{ border: "1px solid gray" }} onClick={openSkyFlagTask}>
                <span className="font-bold">案件をチェックする</span>
              </Button>
            </div>
          </div>

          <div className="w-full sm:w-[50%] items-center justify-center px-4 bg-[#F8F9FA] pt-1">
            <div className="clickable" onClick={openSkyFlagTask}>
              <img src="/images/skyflag-modal.jpg" className="w-full" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </>;

}
